import React, { useContext } from 'react'

import { UIContext } from '../../contexts/ui'

import './Cards.scss'

function Cards(props) {
	const { Theme } = useContext(UIContext)

	const handleClick = () => {
		props.setLocation(props.Name)
		props.openModal()
	}

	return (
		<div className='card shadow mb-4'>
			{/* <!-- Card Header --> */}
			<div
				className={
					'card-header d-flex flex-row align-items-center justify-content-between head_bg Theme' +
					Theme
				}
			>
				<h6
					className={
						'm-0 font-weight-bold text-primary head_btn Theme' +
						Theme
					}
					// onClick="ToggleVisibility('savearea')"
				>
					<span className='padded_large'>{props.Name}</span>
				</h6>
				{props.seachMode ? (
					<button onClick={handleClick}>seach</button>
				) : null}
			</div>
			{/* <!-- Card Body --> */}
			<div className={'card-body Theme' + Theme}>
				{/* <div style='display: inline-block;'></div> */}
				{props.children}
			</div>
		</div>
	)
}

export default Cards
